const ratings = {
  de: ["zufriedenstellend", "mittelmäßig", "nicht zufriedenstellend"],
  en: ["satisfying", "average", "not satisfying"],
  ar: ["جيد", "وسط", "ضعيف"],
};

const contentTypes = {
  sectionHeader: "sectionHeader",
  selectOneQuestion: "selectOneQuestion",
  selectManyQuestion: "selectManyQuestion",
  textQuestion: "textQuestion",
};

const survey = {
  title: "IZA Gemeindeumfrage",
  settings: {
    languages: [
      {
        label: "Deutsch",
        code: "de",
        dir: "ltf",
      },
      {
        label: "English",
        code: "en",
        dir: "ltf",
      },
      {
        label: "عربي",
        code: "ar",
        dir: "rtl",
      },
    ],
    defaultLanguage: "de",
  },
  content: [
    {
      type: contentTypes.sectionHeader,
      config: {
        label: {
          de: "Persönliche Fragen",
          en: "Personal Questions",
          ar: "أسئلة شخصية",
        },
      },
    },

    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "gender",
        mandatory: true,
        label: {
          de: "Geschlecht",
          en: "Gender",
          ar: "الجنس",
        },
        options: {
          de: ["männlich", "weiblich"],
          en: ["male", "female"],
          ar: ["ذكر", "أنثى"],
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "age",
        mandatory: true,
        label: {
          de: "Alter",
          en: "Age",
          ar: "السن",
        },
        options: {
          de: [
            "18 oder jünger",
            "19-26",
            "27-39",
            "40-50",
            "51-60",
            "61-70",
            "71 oder älter",
          ],
          en: [
            "18 or younger",
            "19-26",
            "27-39",
            "40-50",
            "51-60",
            "61-70",
            "71 or older",
          ],
          ar: [
            "١٨ أو أقل",
            "١٩ - ٢٦",
            "٢٧ - ٣٩",
            "٤٠ - ٥٠",
            "٥١ - ٦٠",
            "٦١ - ٧٠",
            "٧١ أو أكبر",
          ],
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "migration_background",
        mandatory: true,
        label: {
          de: "Seit wann leben Sie in Deutschland?",
          en: "Since when do you live in Germany?",
          ar: "منذ متى تعيشون في ألمانيا؟",
        },
        options: {
          de: [
            "in Deutschland geboren",
            "eingewandert vor 2010",
            "eingewandert in 2010 oder später",
            "nur für temporärern Aufenthalt gekommen (Studium, Besuch, Behandlung)",
          ],
          en: [
            "born in Germany",
            "immigrated before 2010",
            "immigrated in 2010 or later",
            "came for temporary stay only (study, visit, medical treatment)",
          ],
          ar: [
            "مولود في ألمانيا",
            "أتيت إلى ألمانيا قبل عام ٢٠١٠",
            "أتيت إلى ألمانيا في عام ٢٠١٠ أو بعد",
            ".. أتيت فقط لإقامة مؤقتة أي لدراسة أو زيارة أو علاج",
          ],
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "family_status",
        mandatory: true,
        label: {
          de: "Familienstand",
          en: "Family Status",
          ar: "الحالة العائلية",
        },
        options: {
          de: ["nicht verheiratet", "verheiratet"],
          en: ["unmarried", "married"],
          ar: ["غير متزوج", "متزوج"],
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "haushalt",
        mandatory: true,
        label: {
          de: "Wie viele Personen leben in Ihrem Haushalt?",
          en: "How many persons live in your household?",
          ar: "ما عدد الأفراد في منزلكم؟",
        },
        options: {
          de: [
            "nur ich",
            "2 Personen",
            "3 bis 4 Personen",
            "5 Personen oder mehr",
          ],
          en: ["only me", "2 persons", "3 to 4 persons", "5 persons or more"],
          ar: ["فقط أنا", "أنا وشخص آخر", "٣ أو ٤ أشخاص", "٥ أشخاص أو أكثر"],
        },
      },
    },

    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "frequency",
        mandatory: true,
        label: {
          de: "Wie häufig sind Sie in der Bilal-Moschee?",
          en: "How often do you visit the Bilal-Mosque?",
          ar: "كم مرة في الأسبوع تأتون إلى مسجد بلال؟",
        },
        options: {
          de: [
            "mehrmals die Woche",
            "1-Mal pro Woche",
            "weniger als 1-Mal pro Woche",
          ],
          en: [
            "several times a week",
            "once per week",
            "less than once per week",
          ],
          ar: [
            "أكثر من مرة واحدة في الأسبوع",
            "مرة واحدة في الأسبوع",
            "أقل من مرة واحدة في الأسبوع",
          ],
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "khutba_language",
        mandatory: true,
        label: {
          de: "In welcher Sprache sollte in der Sommerzeit die erste Predigt beim Freitagsgebet sein?",
          en: "In which language should we give the first of the two khutbas (friday sermons) during summer time?",
          ar: "بأي لغة تفضّل أن تكون الجمعة الأولى أثناء التوقيت الصيفي؟",
        },
        options: {
          de: ["Deutsch", "Arabisch"],
          en: ["German", "Arabic"],
          ar: ["ألماني", "عربي"],
        },
      },
    },

    {
      type: contentTypes.sectionHeader,
      config: {
        label: {
          de: "Bitte bewerten Sie Ihre allgemeine Zufriedenheit mit der Bilal-Moschee",
          en: "Please rate your general satisfcation with the Bilal-Mosque",
          ar: "بشكلٍ عام ما هو تقييمكم لمسجد بلال؟",
        },
      },
    },

    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "rating_overall",
        mandatory: true,
        label: {
          de: "",
          en: "",
          ar: "",
        },
        options: {
          ...ratings,
        },
      },
    },

    {
      type: contentTypes.sectionHeader,
      config: {
        label: {
          de: "Bitte bewerten Sie Ihre Zufriedenheit mit folgenden Themen",
          en: "Please rate your satisfcation with the following topics",
          ar: "يرجى تقييم المسجد في الأمور التالية",
        },
      },
    },

    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "rating_prayers",
        mandatory: true,
        label: {
          de: "Durchführung der Gebete und Gottesdienste ('Ibaadaat)",
          en: "Observance of prayers and other 'ibaadaat",
          ar: "إقامة الصلوات والشعائر الإسلامية",
        },
        options: {
          ...ratings,
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "rating_cleanness",
        mandatory: true,
        label: {
          de: "Sauberkeit und Ordnung",
          en: "Cleanliness and Tidiness",
          ar: "النظافة والنظام",
        },
        options: {
          ...ratings,
        },
      },
    },

    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "rating_management",
        mandatory: true,
        label: {
          de: "Verwaltung und Organisation",
          en: "Management and Administration",
          ar: "الإدارة والتنظيم",
        },
        options: {
          ...ratings,
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "rating_educational",
        mandatory: true,
        label: {
          de: "Bildungs- und Lernangebote",
          en: "Offering of Educaitonal Activities",
          ar: "الأنشطة التعليمية والتربوية",
        },
        options: {
          ...ratings,
        },
      },
    },
    {
      type: contentTypes.selectOneQuestion,
      config: {
        id: "rating_social",
        mandatory: true,
        label: {
          de: "Gemeindeleben und soziale Aktivitäten",
          en: "Community Life and social activities",
          ar: "التواصل والنشاطات الإجتماعية",
        },
        options: {
          ...ratings,
        },
      },
    },

    {
      type: contentTypes.textQuestion,
      config: {
        id: "detailed_feedback",
        mandatory: false,
        label: {
          de: "Haben Sie irgend ein negatives oder positives Feedback oder Anregung?",
          en: "Do you have any negative or positive feedback or recommendations?",
          ar: "هل لديكم أي تعليق سلبي أو إيجابي أو نصيحة حول ما يخص المسجد؟",
        },
        options: {
          maxChars: 1000,
        },
      },
    },
  ],
};

const surveys = {
  iza241: survey,
};

export { contentTypes, surveys };
